<template>
  <div>
    <div class="mx-2">
      <div style="display: flex">
        <div class="col" style="text-align: left">
          <button
            v-can="'mesh.add_coursewrapper'"
            v-if="allows_crud && can_update && matrix2_view"
            class="btn btn-secondary btn-sm"
            @click="$bvModal.show(`new-course-wrapper-modal`)"
          >
            {{ $t("reusable.common.add") }}
            {{
              $getVisibleNames(
                "mesh.coursewrapper",
                false,
                "Envoltorio de Asignaturas"
              )
            }}
          </button>
        </div>
        <div class="col" style="text-align: right">
          <button
            v-can="'mesh.add_coursewrapper'"
            v-if="
              allows_crud &&
              can_update &&
              matrix2_view &&
              base_matters_wrapper.length > 0
            "
            class="btn btn-secondary btn-sm"
            @click="$bvModal.show(`copy-base-matters-wrapper-modal`)"
          >
            {{ $t("reusable.common.copy") }}
            {{
              $getVisibleNames(
                "mesh.basematterwrapper",
                false,
                "Envoltorio de Asignaturas"
              )
            }}
          </button>
        </div>
      </div>
      <div class="d-flex" v-if="!matrix2_view">
        <h3 v-if="!copy_egress_profile_view" class="ml-4">
          {{
            $getVisibleNames(
              "mesh.coursewrapper",
              true,
              "Envoltorios de Asignaturas"
            )
          }}
        </h3>
        <div class="ml-3" v-if="!copy_egress_profile_view">
          <template v-if="selected.length > 0">
            <b-button
              class="mr-1"
              size="sm"
              @click="TemporalChangedCoursesWrapper()"
              >{{ $t("curricularProducts.egressProfile.reassignLevel") }} "{{
                semester_amount
              }}" {{ $t("curricularProducts.egressProfile.to") }}
              {{
                $getVisibleNames(
                  "mesh.coursewrapper",
                  true,
                  "Envoltorios de Asignaturas"
                )
              }}
              {{ $t("curricularProducts.egressProfile.selected") }}</b-button
            >
          </template>
          <template v-else>
            <b-button class="mr-1" size="sm" disabled
              >{{ $t("curricularProducts.egressProfile.reassignLevel") }} "{{
                semester_amount
              }}" {{ $t("curricularProducts.egressProfile.to") }}
              {{
                $getVisibleNames(
                  "mesh.coursewrapper",
                  true,
                  "Envoltorios de Asignaturas"
                )
              }}
              {{ $t("curricularProducts.egressProfile.selected") }}</b-button
            >
          </template>
        </div>
      </div>
      <GenericBTable
        :items="coursesWrapperList"
        :pagination="courses_wrapper.length"
        :fields="courses_wrapper_fields"
        :filter="input_search"
        :filterCustom="filterCustom"
        :show_pagination="true"
        :search_filter="true"
        :columns_display="this.matrix2_view ? true : false"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        @emitChangeSearchField="changeInputSearch"
      >
        <template #head(selected)>
          <b-form-checkbox
            v-model="select_all"
            @change="selectAllCourseWrapper()"
          ></b-form-checkbox>
        </template>
        <template #cell(selected)="row">
          <b-checkbox
            v-model="row.item.selected"
            @change="selectCourseWrapper(row.item.id, $event)"
          ></b-checkbox>
        </template>
        <template v-if="!matrix2_view" #cell(init_level)="row">
          <b-form-input
            style="width: auto"
            type="number"
            min="1"
            v-model="row.item.init_level"
            @update="updateInput()"
            :state="
              row.item.init_level <= semester_amount &&
              row.item.init_level >= 1 &&
              row.item.end_level >= row.item.init_level
            "
            v-b-tooltip.v-danger.noninteractive="
              (row.item.init_level <= semester_amount &&
              row.item.init_level >= 1
                ? ''
                : $t(
                    'curricularProducts.egressProfile.initialLevelMustNotExceed',
                    {
                      entity: $getVisibleNames(
                        'mesh.egressprofile',
                        false,
                        'Perfil de Egreso'
                      ),
                    }
                  )) +
              (row.item.end_level < row.item.init_level
                ? $t(
                    'curricularProducts.egressProfile.initialLevelMustNotBeSuperiorToFinal'
                  )
                : '')
            "
            size="sm"
          ></b-form-input>
        </template>
        <template v-if="!matrix2_view" #cell(end_level)="row">
          <b-form-input
            style="width: auto"
            type="number"
            min="1"
            v-model="row.item.end_level"
            @update="updateInput()"
            :state="
              row.item.end_level <= semester_amount &&
              row.item.end_level >= 1 &&
              row.item.end_level >= row.item.init_level
            "
            v-b-tooltip.v-danger.noninteractive="
              (row.item.end_level <= semester_amount && row.item.end_level >= 1
                ? ''
                : $t(
                    'curricularProducts.egressProfile.initialLevelMustNotExceed',
                    {
                      entity: $getVisibleNames(
                        'mesh.egressprofile',
                        false,
                        'Perfil de Egreso'
                      ),
                    }
                  )) +
              (row.item.end_level < row.item.init_level
                ? $t(
                    'curricularProducts.egressProfile.initialLevelMustNotBeSuperiorToFinal'
                  )
                : '')
            "
            size="sm"
          ></b-form-input>
        </template>
        <template #cell(color)="row">
          <div
            class="course-wrapper-color"
            :style="{
              'background-color': row.item.color,
              color: row.item.color,
            }"
          ></div>
        </template>
        <template #cell(egress_profile_matters)="row">
          <div class="campus-container">
            <div
              v-for="item in getMatterName(row.item.egress_profile_matters)"
              :key="item.id"
              class="campus-div"
            >
              {{ item.name }}
            </div>
          </div>
        </template>
        <template #cell(actions)="row">
          <div class="d-flex">
            <b-button
              size="sm"
              variant="none"
              class="p-1"
              @click="routerPush(row.item.id)"
              ><b-icon
                v-b-tooltip.v-secondary.noninteractive="
                  `${$t(
                    'curricularProducts.egressProfile.goTo'
                  )} ${$getVisibleNames(
                    'manual.matriz_2',
                    false,
                    'Matriz 2'
                  )} ${$t('curricularProducts.egressProfile.of')} ${
                    row.item.name
                  }`
                "
                icon="eye"
                scale="1"
              ></b-icon
            ></b-button>
            <template v-if="allows_crud">
              <button-edit
                v-if="can_update && allows_crud"
                v-can="'mesh.change_coursewrapper'"
                @click="
                  $bvModal.show(`edit-course-wrapper-modal-${row.item.id}`)
                "
                v-b-tooltip.v-secondary.noninteractive="
                  `${$t('reusable.common.edit')} ${$getVisibleNames(
                    'mesh.coursewrapper',
                    false,
                    'Envoltorio de Asignaturas'
                  )}`
                "
              ></button-edit>
              <button-delete
                v-if="can_delete && allows_crud"
                v-can="'mesh.delete_coursewrapper'"
                @click="askForDeleteCourseWrapper(row.item.id)"
                v-b-tooltip.v-secondary.noninteractive="
                  `${$t('reusable.common.delete')} ${$getVisibleNames(
                    'mesh.coursewrapper',
                    false,
                    'Envoltorio de Asignaturas'
                  )}`
                "
              ></button-delete>
            </template>
          </div>
          <b-modal
            :id="`edit-course-wrapper-modal-${row.item.id}`"
            :title="`${$t('reusable.common.edit')} ${$getVisibleNames(
              'mesh.coursewrapper',
              false,
              'Envoltorio de Asignaturas'
            )}`"
            size="lg"
            hide-footer
          >
            <CoursesWrapperForm
              :CourseWrapper="row.item"
              :egress_profile_id="egress_profile_id"
              @updated="slotUpdatedCourseWrapper"
            ></CoursesWrapperForm>
          </b-modal>
        </template>
      </GenericBTable>
    </div>
    <template v-if="!matrix2_view">
      <div class="d-block">
        <template v-if="selected.length > 0 && !copy_egress_profile_view">
          <div class="copy-selection-panel ml-3 mb-3">
            <div class="copy-selection-header">
              <b-icon icon="exclamation-circle" class="mr-1"></b-icon>
              {{ selected.length }}
              {{
                $getVisibleNames(
                  "mesh.coursewrapper",
                  true,
                  "Envoltorios de Asignaturas"
                )
              }}
              {{ $t("curricularProducts.egressProfile.selectedToNotBeCopied") }}
            </div>
            <div class="matters-container mb-2">
              <div
                v-for="item in coursesWrapperList.filter((x) =>
                  selected.includes(x.id)
                )"
                :key="item.id"
                class="matters-div"
              >
                {{ item.name }}
              </div>
            </div>
            <b-button
              size="sm"
              variant="danger"
              @click="TemporalRemoveCoursesWrapper()"
            >
              <b-icon icon="x-circle" class="mr-1" scale="0.9"></b-icon>
              {{ $t("curricularProducts.egressProfile.remove") }}
              {{ $t("curricularProducts.egressProfile.selected") }}
            </b-button>
          </div>
        </template>
        <template v-if="remove_courses_wrapper.length > 0">
          <div class="d-block ml-2 mb-3">
            <h5>
              <template v-if="copy_egress_profile_view"
                >{{ $t("curricularProducts.egressProfile.listOf") }}
              </template>
              {{
                $getVisibleNames(
                  "mesh.coursewrapper",
                  true,
                  "Envoltorios de Asignaturas"
                )
              }}
              <template v-if="!copy_egress_profile_view">
                {{ $t("curricularProducts.egressProfile.toDelete") }}
              </template>
              <template v-else>
                {{
                  $t("curricularProducts.egressProfile.thatWillNotBeCopied")
                }}</template
              >
            </h5>
            <div class="matters-container">
              <div
                v-for="item in remove_courses_wrapper"
                :key="item.id"
                class="matters-div deleted-matter"
              >
                {{ item.name }}
                <b-button
                  variant="none"
                  size="sm"
                  class="m-0 p-0"
                  @click="reintegrateCoursesWrapper(item)"
                >
                  <b-icon
                    icon="x-square"
                    scale="0.9"
                    variant="white"
                    v-b-tooltip.v-secondary.noninteractive="
                      `${$t(
                        'curricularProducts.egressProfile.integrate'
                      )} ${$getVisibleNames(
                        'mesh.coursewrapper',
                        false,
                        'Envoltorio de Asignaturas'
                      )}`
                    "
                  ></b-icon>
                </b-button>
              </div>
            </div>
            <b-button
              v-if="copy_egress_profile_view"
              size="sm"
              variant="outline-secondary"
              class="mt-2"
              @click="reintegrateAllCoursesWrapper()"
            >
              <b-icon icon="arrow-counterclockwise" class="mr-1" scale="0.9"></b-icon>
              {{ $t("curricularProducts.egressProfile.reintegrateAll") }}
            </b-button>
          </div>
        </template>
      </div>
      <!-- <div class="mb-4">
        <h4 v-if="selected.length > 0">
          {{
            $getVisibleNames(
              "mesh.coursewrapper",
              true,
              "Envoltorios de Asignaturas"
            )
          }}
          Seleccionadas
        </h4>
        <div class="matters-container">
          <div
            v-for="item in coursesWrapperList.filter((x) =>
              selected.includes(x.id)
            )"
            :key="item.id"
            class="matters-div"
          >
            {{ item.name }}
          </div>
        </div>
      </div> -->
      <!-- <div class="row">
        <div class="col" style="text-align: right">
          <template v-if="selected.length > 0">
            <b-button class="mr-1" size="sm" @click="removeCourseWrapper()"
              >Remover
              {{
                $getVisibleNames(
                  "mesh.coursewrapper",
                  true,
                  "Envoltorios de Asignaturas"
                )
              }}</b-button
            >
          </template>
          <template v-else>
            <b-button class="mr-1" size="sm" disabled
              >Remover
              {{
                $getVisibleNames(
                  "mesh.coursewrapper",
                  true,
                  "Envoltorios de Asignaturas"
                )
              }}</b-button
            >
          </template>
        </div>
      </div> -->
    </template>
    <b-modal
      :id="`new-course-wrapper-modal`"
      :hide-footer="true"
      :title="`${$t('reusable.common.create')} ${$getVisibleNames(
        'mesh.coursewrapper',
        false,
        'Envoltorio de Asignaturas'
      )}`"
      size="lg"
    >
      <CoursesWrapperForm
        @created="slotCreatedCourseWrapper"
        :egress_profile_id="egress_profile_id"
      ></CoursesWrapperForm>
    </b-modal>
    <b-modal
      :id="`copy-base-matters-wrapper-modal`"
      :hide-footer="true"
      :title="`${$t('reusable.common.copy')} ${$getVisibleNames(
        'mesh.basematterwrapper',
        false,
        'Envoltorio de Asignaturas'
      )}`"
      size="lg"
    >
      <b-form-group
        :label="
          $getVisibleNames(
            'mesh.basematterwrapper',
            false,
            'Envoltorio de Asignaturas'
          ) + ':'
        "
        label-cols="0"
        label-cols-md="4"
        class="w-100 my-0 py-0"
      >
        <b-form-select
          v-model="selected_base_matter_wrapper"
          :options="baseMattersWrapperList"
          value-field="id"
          text-field="label"
          size="sm"
        ></b-form-select>
      </b-form-group>
      <b-button
        :disabled="selected_base_matter_wrapper == null"
        @click="createCourseWrapper()"
        class="mt-1 mx-1 float-right"
        >{{ $t("reusable.common.create") }}
        {{
          $getVisibleNames(
            "mesh.coursewrapper",
            true,
            "Envoltorios de Asignaturas"
          )
        }}</b-button
      >
    </b-modal>
  </div>
</template>
<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { toast } from "@/utils/utils";

export default {
  name: "CoursesWrapperView",
  components: {
    CoursesWrapperForm: () =>
      import("@/components/mesh/Matrix2/CoursesWrapper/CoursesWrapperForm"),
    GenericBTable: () => import("@/components/reusable/GenericBTable"),
  },
  props: {
    egress_profile_id: {
      type: Number,
      required: true,
    },
    allows_crud: {
      type: Boolean,
      required: true,
    },
    matrix2_view: {
      type: Boolean,
      default: true,
    },
    copy_egress_profile_view: {
      type: Boolean,
      default: false,
    },
    semester_amount: {
      default: 1,
    },
  },
  data() {
    return {
      input_search: "",
      sortBy: "",
      sortDesc: false,
      select_all: null,
      selected: [],
      selected_base_matter_wrapper: null,
      list_courses_wrapper: [],
      remove_courses_wrapper: [],
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      courses_wrapper: names.COURSES_WRAPPER,
      egressProfiles: names.EGRESS_PROFILES,
      careers: names.CAREERS,
      matters: names.MATTERS,
      formationAreas: names.FORMATION_AREAS,
      formationLines: names.FORMATION_LINES,
      egress_profile_matters: names.EGRESS_PROFILES_MATTERS,
      base_matters_wrapper: names.BASE_MATTERS_WRAPPER,
    }),
    egressProfile() {
      return this.egressProfiles.find((x) => x.id == this.egress_profile_id);
    },
    career() {
      if (!this.egressProfile) return null;
      return this.careers.find((x) => x.id == this.egressProfile.career);
    },
    can_update() {
      if (
        (this.user &&
          [
            "DIRECTIVOS ACADÉMICOS INSTITUCIONALES",
            "DIRECTIVOS ACADÉMICOS (CAMPUS)",
          ].some((group) => this.user.group_names.includes(group))) ||
        this.user.is_superuser
      )
        return true;
      if (
        this.career &&
        this.egress_profile_id &&
        this.user &&
        !["ADMINISTRATIVOS INSTRUCCIONALES"].some((group) =>
          this.user.group_names.includes(group)
        )
      ) {
        return (
          [
            "DIRECTIVOS FACULTAD O ESCUELA",
            "DIRECTORES DE CARRERA",
            "DIRECTORES DE CARRERA (CAMPUS)",
          ].some((group) => this.user.group_names.includes(group)) &&
          (this.$hasObjectPermission(
            "mesh.faculty",
            "change",
            this.career.faculty
          ) ||
            this.$hasObjectPermission(
              "mesh.egressprofile",
              "change",
              this.egress_profile_id
            ))
        );
      }
      return false;
    },
    can_delete() {
      if (
        (this.user &&
          [
            "DIRECTIVOS ACADÉMICOS INSTITUCIONALES",
            "DIRECTIVOS ACADÉMICOS (CAMPUS)",
          ].some((group) => this.user.group_names.includes(group))) ||
        this.user.is_superuser
      )
        return true;
      if (
        this.career &&
        this.egress_profile_id &&
        this.user &&
        !["ADMINISTRATIVOS INSTRUCCIONALES"].some((group) =>
          this.user.group_names.includes(group)
        )
      ) {
        return (
          [
            "DIRECTIVOS FACULTAD O ESCUELA",
            "DIRECTORES DE CARRERA",
            "DIRECTORES DE CARRERA (CAMPUS)",
          ].some((group) => this.user.group_names.includes(group)) &&
          (this.$hasObjectPermission(
            "mesh.faculty",
            "delete",
            this.career.faculty
          ) ||
            this.$hasObjectPermission(
              "mesh.egressprofile",
              "delete",
              this.egress_profile_id
            ))
        );
      }
      return false;
    },
    baseMattersWrapperList() {
      return this.base_matters_wrapper.map((x) => ({
        ...x,
        label:
          x.name +
          " - " +
          this.$t("curricularProducts.egressProfile.ni") +
          ": " +
          x.init_level +
          " - " +
          this.$t("curricularProducts.egressProfile.nf") +
          ": " +
          x.end_level,
      }));
    },
    coursesWrapperList() {
      if (this.matrix2_view) {
        let list = [
          ...this.courses_wrapper.filter(
            (x) => x.egress_profile == this.egress_profile_id
          ),
        ];
        return list;
      } else {
        let list = this.list_courses_wrapper;
        return list.sort(function (a, b) {
          if (a.init_level > b.init_level) return 1;
          if (a.init_level < b.init_level) return -1;
          if (a.end_level > b.end_level) return 1;
          if (a.end_level < b.end_level) return -1;
          return 0;
        });
      }
    },
    // allows_crud() {
    //   const has_permission = this.$hasPermissions("mesh.add_coursewrapper");
    //   if (has_permission) return has_permission;
    //   else return false;
    // },
    courses_wrapper_fields() {
      return [
        !this.matrix2_view
          ? {
              key: "selected",
              label: this.copy_egress_profile_view
                ? this.$t("curricularProducts.egressProfile.exclude")
                : this.$t("curricularProducts.egressProfile.select"),
              display_column: !this.matrix2_view ? true : false,
              thStyle: { width: "1%" },
            }
          : { key: "", label: "", display_column: false },
        {
          key: "name",
          label: String(
            this.$getVisibleNames(
              "mesh.coursewrapper",
              true,
              "Envoltorios de Asignaturas"
            )
          ),
          sortable: true,
          thClass: "text-center align-middle",
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "description",
          label: this.$t("reusable.common.description"),
          sortable: true,
          thClass: "text-center align-middle",
          tdClass: "text-left",
          display_column: this.matrix2_view ? true : false,
        },
        {
          key: "init_level",
          label: this.$t("curricularProducts.egressProfile.initialLevel"),
          sortable: true,
          thClass: "text-center align-middle",
          tdClass: "text-center",
          display_column: true,
        },
        {
          key: "end_level",
          label: this.$t("curricularProducts.egressProfile.finalLevel"),
          sortable: true,
          thClass: "text-center align-middle",
          tdClass: "text-center",
          display_column: true,
        },
        {
          key: "formation_area",
          label: this.$getVisibleNames(
            "mesh.formationarea",
            false,
            "Área De Formación"
          ),
          sortable: false,
          display_column: this.matrix2_view ? true : false,
          tdClass: "text-center",
          formatter: (value) => {
            return this.getFormationArea(value);
          },
        },
        {
          key: "formation_line",
          label: this.$getVisibleNames(
            "mesh.formationline",
            false,
            "Línea De Formación"
          ),
          sortable: false,
          tdClass: "text-center",
          display_column: this.matrix2_view ? true : false,
          formatter: (value) => {
            return this.getFormationLine(value);
          },
        },
        {
          key: "credits",

          label: this.$getVisibleNames(
            "manual.credits",
            true,
            "Créditos SCT Totales"
          ),
          sortable: true,
          thClass: "text-center align-middle",
          tdClass: "text-center",
          display_column: this.matrix2_view ? true : false,
        },
        {
          key: "hours",
          label: this.$t(
            "curricularProducts.egressProfile.totalPedagogicalHours"
          ),
          sortable: false,
          thClass: "text-center align-middle",
          tdClass: "text-center",
          display_column: true,
        },
        // {
        //   key: "color",
        //   label: "Color",
        //   sortable: false,
        //   display_column: true,
        // },
        {
          key: "egress_profile_matters",
          label: String(
            this.$getVisibleNames(
              "mesh.egressprofilematter",
              true,
              "Asignaturas"
            )
          ),
          thClass: "text-center align-middle",
          tdClass: "text-left",
          display_column: this.matrix2_view ? true : false,
        },
        {
          key: "actions",
          label: "",
          display_column: this.matrix2_view ? true : false,
          thClass: "noprint",
          tdClass: "noprint",
        },
      ];
    },
  },
  methods: {
    updateInput() {
      this.$emit(
        "list_courses_wrapper",
        this.list_courses_wrapper,
        this.remove_courses_wrapper
      );
    },
    createCourseWrapper() {
      if (this.selected_base_matter_wrapper != null) {
        this.$restful
          .Get(
            `/mesh/base_matter_wrapper_to_course_wrapper/?base_matter_wrapper=${this.selected_base_matter_wrapper}&egress_profile=${this.egress_profile_id}`
          )
          .then((response) => {
            this.$store.dispatch(
              names.FETCH_COURSE_WRAPPER,
              response.course_wrapper
            );
            this.$store.dispatch(names.FETCH_EGRESS_PROFILES_MATTERS, {
              egress_profile_id: this.egress_profile_id,
            });
            this.$store.dispatch(names.FETCH_MATTERS, {
              egress_profile_id: this.egress_profile_id,
            });
            this.$bvModal.hide(`copy-base-matters-wrapper-modal`);
          });
      }
    },
    TemporalRemoveCoursesWrapper() {
      this.list_courses_wrapper
        .filter((x) => this.selected.includes(x.id))
        .forEach((x) => {
          x.selected = false;
          this.remove_courses_wrapper.push(x);
          const index = this.list_courses_wrapper.findIndex(
            (a) => a.id == x.id
          );
          if (index != -1) this.list_courses_wrapper.splice(index, 1);
        });
      this.selected = [];
      this.select_all = false;
      this.$emit(
        "list_courses_wrapper",
        this.list_courses_wrapper,
        this.remove_courses_wrapper
      );
    },
    TemporalChangedCoursesWrapper() {
      this.list_courses_wrapper
        .filter((x) => this.selected.includes(x.id))
        .forEach((x) => {
          x.init_level = this.semester_amount;
          x.end_level = this.semester_amount;
          x.selected = false;
        });
      this.selected = [];
      this.select_all = false;
      this.$emit(
        "list_courses_wrapper",
        this.list_courses_wrapper,
        this.remove_courses_wrapper
      );
    },
    reintegrateCoursesWrapper(matter) {
      const index = this.remove_courses_wrapper.findIndex(
        (x) => x.id == matter.id
      );
      if (index != -1) {
        this.remove_courses_wrapper.splice(index, 1);
        this.list_courses_wrapper.push(matter);
      }
      this.$emit(
        "list_courses_wrapper",
        this.list_courses_wrapper,
        this.remove_courses_wrapper
      );
      this.select_all = false;
    },
    reintegrateAllCoursesWrapper() {
      while (this.remove_courses_wrapper.length > 0) {
        this.list_courses_wrapper.push(this.remove_courses_wrapper.pop());
      }
      this.$emit(
        "list_courses_wrapper",
        this.list_courses_wrapper,
        this.remove_courses_wrapper
      );
      this.select_all = false;
    },
    selectCourseWrapper(matter_id) {
      if (this.copy_egress_profile_view) {
        this.directExcludeCourseWrapper(matter_id);
        return;
      }
      const index = this.selected.findIndex((x) => x == matter_id);
      if (index != -1) this.selected.splice(index, 1);
      else this.selected.push(matter_id);
    },
    directExcludeCourseWrapper(wrapper_id) {
      const index = this.list_courses_wrapper.findIndex(
        (x) => x.id == wrapper_id
      );
      if (index != -1) {
        const wrapper = this.list_courses_wrapper[index];
        wrapper.selected = false;
        this.remove_courses_wrapper.push(wrapper);
        this.list_courses_wrapper.splice(index, 1);
        this.$emit(
          "list_courses_wrapper",
          this.list_courses_wrapper,
          this.remove_courses_wrapper
        );
      }
    },
    selectAllCourseWrapper() {
      if (this.copy_egress_profile_view) {
        if (this.select_all) {
          const ids = this.list_courses_wrapper.map((x) => x.id);
          ids.forEach((id) => this.directExcludeCourseWrapper(id));
        }
        this.select_all = false;
        return;
      }
      let list = [];
      if (!this.select_all) {
        this.coursesWrapperList.forEach((x) => {
          x.selected = false;
        });
        this.selected = [];
      } else {
        this.coursesWrapperList.forEach((x) => {
          list.push(x.id);
          x.selected = true;
        });
        this.selected = [...new Set(list)];
      }
    },
    // removeCourseWrapper() {
    //   this.$swal({
    //     title: `¿Desea remover las ${this.$getVisibleNames(
    //       "mesh.coursewrapper",
    //       true,
    //       "Envoltorios de Asignaturas"
    //     )} seleccionadas?`,
    //     width: "auto",
    //     text: `Esta acción no se podrá revertir y se desvinculará los objetos seleccionados de este ${this.$getVisibleNames(
    //       "mesh.egressprofile",
    //       false,
    //       "Perfil de Egreso"
    //     )}. `,
    //     type: "warning",
    //     showCancelButton: true,
    //   }).then((result) => {
    //     if (result.value) {
    //       this.removeCoursesWrapper(this.selected);
    //     }
    //   });
    // },
    // async removeCoursesWrapper(course_wrapper) {
    //   for await (let wrapper_id of course_wrapper) {
    //     await this.$store.dispatch(names.DELETE_COURSE_WRAPPER, wrapper_id);
    //   }
    //   this.selected = [];
    //   this.selected_all = false;
    // },
    routerPush(courses_wrapper_id) {
      this.$router.push({
        name: "Matrix2View",
        params: {
          egress_profile_id: this.egress_profile_id,
          courses_wrapper_id: courses_wrapper_id,
        },
      });
      this.$emit("closeModal");
    },
    filterCustom(row) {
      if (
        this.$filtered(String(row.name), this.input_search) ||
        this.$filtered(String(row.description), this.input_search) ||
        this.$filtered(String(row.init_level), this.input_search) ||
        this.$filtered(String(row.end_level), this.input_search) ||
        this.$filtered(String(row.credits), this.input_search) ||
        this.$filtered(
          String(this.getFormationArea(row.formation_area)),
          this.input_search
        ) ||
        this.$filtered(
          String(this.getFormationLine(row.formation_line)),
          this.input_search
        ) ||
        this.egress_profile_matters.filter(
          (x) =>
            this.matters.find(
              (matter) =>
                this.$filtered(matter.name, this.input_search) &&
                x.matter == matter.id
            ) && row.egress_profile_matters.includes(x.id)
        ).length > 0
      ) {
        return true;
      } else {
        false;
      }
    },
    getFormationArea(formation_area_id) {
      if (!this.formationAreas) return this.$t("reusable.common.notApplicable");
      const formation_area = this.formationAreas.find(
        (x) => x.id == formation_area_id
      );
      return formation_area
        ? formation_area.name
        : this.$t("reusable.common.notApplicable");
    },
    getFormationLine(formation_line_id) {
      if (!this.formationLines) return this.$t("reusable.common.notApplicable");
      const formation_line = this.formationLines.find(
        (x) => x.id == formation_line_id
      );
      return formation_line
        ? formation_line.name
        : this.$t("reusable.common.notApplicable");
    },
    getMatterName(egress_profile_matters) {
      let matters = this.egress_profile_matters
        .filter(
          (x) =>
            egress_profile_matters.includes(x.id) &&
            x.egress_profile == this.egress_profile_id
        )
        .map((x) => x.matter);
      matters = [...new Set(matters)];
      if (matters.length > 0) {
        const list = this.matters.filter((element) =>
          matters.includes(element.id)
        );
        return list.sort((a, b) => {
          if (a.name > b.name) return 1;
          if (a.name < b.name) return -1;
          return 0;
        });
      } else return [];
    },
    changeInputSearch(input_search) {
      this.input_search = input_search;
    },
    askForDeleteCourseWrapper(course_wrapper_id) {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "mesh.coursewrapper",
            false,
            "Envoltorio de Asignaturas"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch(names.DELETE_COURSE_WRAPPER, course_wrapper_id)
            .then(() => {
              toast(
                this.$getVisibleNames(
                  "mesh.coursewrapper",
                  false,
                  "Envoltorio de Asignaturas"
                ) +
                  " " +
                  this.$t("reusable.common.deleted")
              );
            });
        }
      });
    },
    slotCreatedCourseWrapper() {
      this.$bvModal.hide("new-course-wrapper-modal");
    },
    slotUpdatedCourseWrapper(course_wrapper) {
      this.$bvModal.hide(`edit-course-wrapper-modal-${course_wrapper.id}`);
    },
  },
  watch: {
    selected() {
      if (
        this.selected.length == this.coursesWrapperList.length &&
        this.coursesWrapperList.length > 0
      ) {
        this.select_all = true;
      } else if (
        this.selected.length != this.coursesWrapperList.length &&
        this.coursesWrapperList.length > 0
      )
        this.select_all = false;
    },
  },
  mounted() {
    this.select_all = false;
    this.selected = [];
    this.list_courses_wrapper = [];
    if (!this.matrix2_view) {
      if (!this.copy_egress_profile_view) {
        this.list_courses_wrapper = this.courses_wrapper
          .filter(
            (x) =>
              x.egress_profile == this.egress_profile_id &&
              x.init_level > this.semester_amount
          )
          .map((objeto) => ({ ...objeto }));
      } else {
        this.list_courses_wrapper = this.courses_wrapper
          .filter((x) => x.egress_profile == this.egress_profile_id)
          .map((objeto) => ({ ...objeto }));
      }
      this.$emit(
        "list_courses_wrapper",
        this.list_courses_wrapper,
        this.remove_courses_wrapper
      );
    }
  },
  created() {
    if (this.formationAreas.length == 0) {
      this.$store.dispatch(names.FETCH_FORMATION_AREAS);
    }
    this.$store.dispatch(names.FETCH_BASE_MATTERS_WRAPPER);
    // this.$store.dispatch(names.FETCH_COURSES_WRAPPER, {
    //   egress_profile_id: this.egress_profile_id,
    // });
  },
};
</script>
<style scoped>
.campus-div {
  background-color: var(--primary-color);
  color: white;
  max-width: fit-content;
  border-radius: 3px;
  margin: 0.1em 0.1em;
  padding: 1px 4px;
  flex-grow: 1;
  font-size: var(--thirth-font-size);
  text-align: center;
}
.campus-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: left;
}
th {
  background-color: var(--primary-color);
  border-radius: 6px;
  box-shadow: 1px 1px 3px rgb(72, 72, 72);
}
.course-wrapper-color::before {
  min-width: 100px !important;
  height: 20px !important;
  opacity: 1;
  content: " #";
}
.matters-div {
  background-color: var(--primary-color);
  color: white;
  max-width: fit-content;
  border-radius: 3px;
  margin: 0.1em 0.1em;
  padding: 1px 4px;
  flex-grow: 1;
  font-size: var(--thirth-font-size);
  text-align: center;
}
.matters-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.deleted-matter {
  background-color: red !important;
}
.copy-selection-panel {
  padding: 0.75rem;
  background-color: #fff8e1;
  border: 1px solid #ffcc02;
  border-radius: 6px;
}
.copy-selection-header {
  font-weight: 600;
  font-size: var(--secondary-font-size, 0.9rem);
  margin-bottom: 0.5rem;
  color: #856404;
}
</style>